<template>
    <v-dialog v-model="showDynamicPopup" :width="700">
        <div class="dynamic-popup">
            <div class="popup-header">
                <div class="popup-title">
                    <img class="dynamic" :src="require('@/assets/icons/dynamic.svg')" />
                    <span>Dynamic Intelligence (DI)</span>
                </div>
                <button class="circle" @click="closePopup()">
                    <img :src="require('@/assets/icons/close.svg')" alt="" />
                </button>
            </div>
            <div class="popup-subtitle">
                <span>
                    Add strategic depth and more detail with our Dynamic Intelligence feature
                </span>
            </div>
            <div class="popup-content">
                <div class="title">
                    <span>Real-time think engine. Surfacing questions, conducting live research, and presenting insights you can incorporate.</span>
                </div>
                <div style="padding-left: 1rem;">
                    <li>Strategic Guidance and Questioning</li>
                    <li>Live Market Context</li>
                    <li>Smart Messaging</li>
                </div>
            </div>
            <div class="footer-btn">
                <button class="standard" @click="$emit('generate-standard')">
                    <div class="standard-title"> Standard Generation</div>
                    <span class="footer-subtitle">No Credits Required</span>
                </button>
                <button class="fine-tune" @click="$emit('generate-dynamic')">
                    <div class="fine-tune-title">
                        <img :src="require('@/assets/icons/star.svg')" alt="star" class="credit" />
                        Agentic Consulting with DI
                    </div>
                    <span class="footer-subtitle">20 Credits Required</span>
                </button>

            </div>
        </div>

    </v-dialog>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean
        }
    },
    computed: {
        showDynamicPopup: {
            get() {
                return this.modelValue;
            }
        }
    },
    methods: {
        closePopup() {
            this.$emit("update:modelValue", false);
        },
    }
}
</script>

<style scoped>
.dynamic-popup {
    width: 100%;
    background-color: white;
    border-radius: 12px;
    padding: 2em;
    display: flex;
    flex-direction: column;
    align-items: left;
    gap: 2em;
    font-family: 'Inter', sans-serif;
}

.popup-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.popup-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.popup-title span {
    font-size: 28px;
    background: var(--primary-gradient-with-white);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
}

.popup-header .dynamic {
    width: 40px;
    height: 40px;
}

.popup-subtitle {
    color: #737373;
    font-weight: 500;
    font-size: 16px;
    font-style: italic;
}

.popup-content .title {
    color: black;
}

.popup-content {
    background-color: #FF780014;
    padding: 8px;
    color: #737373;
    display: flex;
    flex-direction: column;
    gap: 8px;

}

.footer-btn {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;
}

.standard {
    border-radius: 8px;
    align-items: center;
    padding: 8px;
    justify-content: center;
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid black;
}

.fine-tune {
    border-radius: 8px;
    display: flex;
    padding: 8px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: var(--primary-gradient-with-white);
    flex: 1;
    color: var(--secondary-font-color);
}

.standard-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 400;
    font-size: 16px;
    color: black;
}

.fine-tune-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 400;
    font-size: 16px;
    color: white;
}

.credit {
    width: 24px;
    height: 24px;
}

.footer-subtitle {
    font-size: 14px;
    color: var(--secondary-font-color);
}

.standard .footer-subtitle {
    font-size: 14px;
    color: var(--light-grey-color);
}

.circle {
    position: absolute;
    top: 20px;
    right: 40px;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 1em;
    border: 2px solid #D4D4D4;
}

.popup-details {
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 0px 12px 0px 8px;
}

.details-title {
    font-size: 28px;
    font-weight: 600;
    text-align: left;
}

.details-subtitle {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #737373;
}

.popup-points {
    color: #404040;
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    padding-left: 2em;
}

.popup-points li {
    padding: 4px 0px;
    font-weight: 500;
}
</style>